// export default {}
import ScrollToTop from './ScrollToTop';
import ScrollToTopButton from './ScrollToTopButton';
import HashHandler from './HashHandler'
import Helmet from './Helmet'
import PageLoading from './PageLoading'
export default {
    methods: [ScrollToTop, ScrollToTopButton, HashHandler, Helmet],
    components: { PageLoading }
}